<template>
<div class="form-months checkbox-button">
  <b-form-checkbox-group buttons button-variant="default btn-sm" v-model="form[field]" :options="meses" :name="field" />
  <div class="text-right">
    <b-button variant="primary" @click="selectAll">Ano todo</b-button>
  </div>
</div>
</template>

<script>

import meses from '@/data/meses.json'

export default {

  name: 'form-months',
  props: ['form', 'field'],
  data() {
    return {
      meses: meses,
    }
  },
  methods: {
    selectAll() {
      this.form[this.field] = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"]
    }
  }
};
</script>
